// Auto-refactored from translations.js on 2026-08-19
// Locale: lb

const lb = {
  wieMoeglich: {
    question: 'Wéi ass dat méiglech?',
    answer: "Mir hunn d'Wäertschöpfungskette nei geduecht."
  },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'De STIG ROCK Wee',
    fazit: 'Duerch déi verkierzt Liwwerkette falen déi gréisst Käschtepositioune ewech.',
    fazitBigPre: 'Dat erméiglecht e Präisnooloss vu bis zu',
    fazitBigValue: '80%',
    steps: [ 'Minn', 'Schläifatelier', 'Zertifizéierung', 'Endclient' ]
  },
  nav: { language: 'Sprooch', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Eng eenzegaarteg Méiglechkeet',
    subtitle: 'Verméigen zukunftsorientéiert opbauen.',
    description: 'STIG ROCK ass eng international Plattform, déi de Leit Zougang zu natierleche Diamanten, nohaltegem Verméigensopbau an enger eenzegaarteger Community bitt.',
    scroll: 'Scrolle fir ze entdecken'
  },
  disclaimer: {
    overline: 'Rechtlechen Hiweis',
    title: 'Disclaimer',
    paragraphs: [
      'Dës Presentatioun déngt reng zur Informatioun a stellt keng Finanz-, Analage- oder Steierberodung duer.',
      'STIG ROCK ass kee Finanzprodukt, mee bezitt sech op natierlech Diamanten als Sachwäerter.',
      'Fir Wäertentwécklungen, Gewënn oder Erträg gëtt keng Garantie iwwerholl. Vergaangen Entwécklungen sinn keng Indikatioun fir zukünfteg Resultater.',
      'All duergestallt Berechnungen am Zesummenhang mat Kommissioune sinn reng exemplaresch a stellen och keng Garantie duer.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'OP STRUKTUR', 'OPGEBAUT' ],
    body: 'STIG Group ass en internationale Konzern, opgebaut op Kloerheet, Verantwortung a laangfristegem Wäert. All Mark, all Vorhaben an all Partnerschaft follegt engem eenzege Standard — ouni Ofkierzungen, ouni Ausnamen.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'OP STRUKTUR', 'OPGEBAUT' ],
        body: 'STIG Group ass en internationale Konzern, opgebaut op Kloerheet, Verantwortung a laangfristegem Wäert. All Mark, all Vorhaben an all Partnerschaft follegt engem eenzege Standard — ouni Ofkierzungen, ouni Ausnamen.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ "D'WELT VUN", 'EXKLUSIVEN DIAMANTEN' ],
        body: 'STIG ROCK ass e modernt Konzept vun der STIG Group, dat héichwäerteg GIA-zertifizéiert Diamanten mat transparenten Strukturen an enger exklusiver Clienterfahrung verbënnt. Kloer Léisungspläng, professionell Ofwicklung an international Ausriichtung.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'INTERNATIONALEN', 'DIAMANTENHANDEL' ],
        body: 'STIG International ass Deel vun der STIG Group a spezialiséiert op den internationalen Handel mat GIA-zertifizéierten Diamanten. Fokus op Qualitéit, Vertrauen a modern Handelsstrukture mat globale Partnerschaften.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'VERANTWORTUNG', 'VUN DER MINN UN' ],
        body: 'Ethical Mines steet fir verantwortungsvollen Ofbau, réckverfolgbar Hierkonft a konfliktfräi Diamanten. Vun der Minn bis op de Maart — lückenlos Dokumentatioun fir Transparenz, Integrität a laangfristeg Verantwortung laanscht déi ganz Liwwerkette.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamanten',
    stigDrawback: 'Reelle Wäertspäicher',
    overline: 'Méiglechkeeten',
    title: 'Méiglechkeeten fir de Verméigensopbau',
    subtitle: 'Traditionell Weeër am Verglach.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex oder Krypto',
        drawback: 'héich spekulativ, onberechenbar, komplex'
      },
      {
        tag: 'Aktien',
        name: 'Bourse-Handel',
        drawback: 'Schwankungsrisiko, néidegt Wëssen, Zäitopwand'
      },
      {
        tag: 'Krypto',
        name: 'Handel',
        drawback: 'Volatilitéit, Reguléierungsrisiko, Sécherheetslücken'
      }
    ]
  },
  chance: {
    overline: 'Diamanten',
    title: 'Déi ënnerschatzt Chance',
    body: 'Diamanten zielen zënter Joren zu de wäertstabilsten a chancenräichsten Analageformen, mee bis elo hunn nëmme wéineg dëst Potenzial genotzt.',
    callout: "Mat eiser STIG ROCK opene mir fir d'éischt Kéier jidderengem den Zougang zu dësen aussergewéinleche Méiglechkeeten."
  },
  wertentwicklung: {
    overline: 'Wäertentwécklung 1995 — 2025',
    title: 'Eng Geschicht iwwer Wäert.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamanten',
    diamondValue: '+185%',
    note: 'Entwécklung zënter 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Haaptgrënn',
    title: 'Sechs Grënn fir Diamanten',
    lead: 'Diamanten si real Sachwäerter, déi onofhängeg vu Wärungen a Finanzsystemer bestinn — an zënter Joerhonnerten hire Wäert bewahren.',
    items: [
      {
        n: '01',
        title: 'Krisefest Wäertstabilitéit',
        body: 'Sachwäert-Garantie. Onofhängeg vu Wärungen a Finanzsystemer.'
      },
      {
        n: '02',
        title: 'Déi ultimativ Mobilitéit',
        body: 'Kleng, einfach ze verstoppen an ze transportéieren.'
      },
      {
        n: '03',
        title: 'Diversifikatioun & Knappheet',
        body: 'Offer-Engpäss an natierlech Limitatioun.'
      },
      { n: '04', title: 'Laangfristegt Wuesstem', body: '+185% zënter 1995.' },
      {
        n: '05',
        title: 'Transparenz & Exklusivitéit',
        body: "D'4 Cʼs als Garantie: Carat, Color, Clarity, Cut."
      },
      {
        n: '06',
        title: 'Reserv vun de Kinnekshaiser',
        body: 'Sogar Kinnekshaiser notzen Diamanten als Verméigensreserv.'
      }
    ]
  },
  markt: {
    overline: 'Maartvolumen',
    title: '99 — 108 Mrd. USD',
    sub: 'Handelsvolumen am Joer 2025',
    forecast: 'Prognos bis ~2032 / 2034: ca. 140 – 168 Mrd. USD bei moderatem Wuesstem (~4 – 5 % p.a.).',
    source: 'Quell: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovation',
    title: "Eng Innovatioun. Weltwäit fir d'éischt Kéier.",
    body: 'STIG ROCK ass déi éischt Plattform weltwäit, déi et de Leit erméiglecht, am Diamantemaart zousätzlech zur Wäertsteigerung e passivt Akommes ze generéieren.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Regëster-Nr. DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: "Iwwer d'Entreprise",
    titleLines: [ 'INTERNATIONAAL', 'STRUKTUR', 'KLOER VISION' ],
    body: 'STIG ROCK gouf gegrënnt, fir den Diamantemaart méi transparent, méi modern a méi clientorientéiert ze gestalten — mat Fokus op Vertrauen, Sécherheet a laangfristeg Struktur.'
  },
  sicherheit: {
    overline: 'Qualitéit & Sécherheet',
    title: 'Gemological Institute of America',
    body: "Zertifizéiert Expertise fir Är Diamanten. D'GIA bewäert all Steen mat héchster Präzisioun a laangjäreger Erfahrung — verléisslech Wäertgutachten fir eis Entreprise an eis Clienten.",
    transparency: 'All Diamant erfëllt héich Qualitéitsstandarde a gëtt vu renomméierten Organisatioune gepréift an zertifizéiert. All Steen ass eenzegaarteg an erhält en individuellen Zertifikat.'
  },
  plaene: {
    overline: 'Solution Pläng (SP)',
    title: 'Eng eenzegaarteg Produktinnovatioun',
    sub: 'Sechs abgestufte Solution Pläng — vun $1K bis $100K+, jee mat steigendem Rabatt pro Mount an iwwer déi ganz Lafzäit.',
    recommended: 'Beléift',
    oneYear: '1 Joer',
    rowLabels: {
      delivery: 'Liwwerzäit',
      price: 'Produkt Präis',
      carat: 'Karat',
      monthly: 'Rabatt (Mount)',
      totalDiscount: 'Rabatt (Total)',
      duration: 'Lafzäit'
    },
    headers: {
      plan: 'Plan',
      from: 'Vun',
      carat: 'Karat',
      monthly: 'Rabatt / Mount',
      total: 'Rabatt Total',
      duration: 'Lafzäit'
    },
    duration: '1 Joer',
    footnote: 'All Präisangabe sinn ouni Gewähr an ofhängeg vu Qualitéit, Nofro an aktueller Maartentwécklung. Solution Pläng sinn och fir 2 Joer méiglech.'
  },
  plaeneVIP: {
    overline: 'Solution Pläng + VIP-Paket',
    title: 'Méi Virdeeler mam VIP-Paket',
    sub: 'Kombinéier däin Solution Plan mat engem VIP-Paket a profitéier vun zousätzleche Präisvirdeeler vu bis zu 3 %. Sou erhéichs du däi Gesamtrabatt a secures dir nach attraktiver Konditiounen.',
    rowLabels: {
      delivery: 'Liwwerzäit',
      price: 'Produkt Präis',
      carat: 'Karat',
      monthly: 'Rabatt (Mount)',
      totalDiscount: 'Rabatt (Total)',
      vip1: 'VIP-Paket 1 (+1%)',
      vip2: 'VIP-Paket 2 (+2%)',
      vip3: 'VIP-Paket 3 (+3%)'
    },
    footnote: 'All Präisangabe sinn ouni Gewähr an ofhängeg vu Qualitéit, Nofro an aktueller Maartentwécklung.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Méi Virdeeler mam VIP-Paket',
    sub: 'Kombinéier däin Solution Plan mat engem VIP-Paket a profitéier vun zousätzleche Präisvirdeeler vu bis zu 3 %. Sou erhéichs du däi Gesamtrabatt a secures dir nach attraktiver Konditiounen.',
    options: [
      {
        key: 'deliver',
        title: 'Méi Virdeeler mam VIP-Paket',
        body: 'Diamanten (Karat) zum Präis vun dengem DS-Plan*'
      },
      {
        key: 'sellToUs',
        title: 'An eis verkafen',
        body: 'Du kanns deng Diamanten un eis zum vum dir bezuelte Kafpräis zeréckverkafen.'
      },
      {
        key: 'sellThirdParty',
        title: 'An Drëtt verkafen',
        body: 'Du kanns deng Diamanten un Drëtt weiderverkafen.'
      }
    ],
    footnote: '*DS-Plan steet fir Solution Plan.'
  },
  tradWeg: {
    overline: 'Traditionellen Handel',
    title: 'Den traditionelle Wee',
    sub: 'Ier en Diamant den Endclient erreecht, entstinn duerch Tëschen-, Grouss- an Einzelhandel erheblech Handelsspannen, par rapport zum Réidiamantepräis aus der Minn.',
    steps: [
      { title: 'Minn', subtitle: 'Réidiamanten' },
      { title: 'Tëschen-Händler', subtitle: 'Réidiamanten Akaaf' },
      { title: 'Schläiferei', subtitle: 'Schlëff zu Schmuckdiamanten' },
      { title: 'Zertifizéierung', subtitle: 'duerch unerkannt Instituter wéi GIA' },
      { title: 'Diamanten Bourse', subtitle: 'Verkaf u Grousshandel' },
      { title: 'Grousshandel', subtitle: 'Verkaf un Einzelhandel' },
      { title: 'Einzelhandel', subtitle: 'z. B. Bijoutieren' },
      { title: 'Endclienten', subtitle: 'Kaf vun Diamanten' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'VIP-Pakete',
    sub: 'Gëlteg fir 12 Méint op all vun dir gezeechent Solution Pläne. Jee no VIP-Paket: +1% bis +3% zousätzleche Rabatt',
    cardKicker: 'zousätzlech – op all',
    cardKicker2: 'Solution Pläne',
    tip: 'Empfehlung: Ab $2.800 Investitionsvolumen lohnt sich VIP-Paket 3 am meisten.',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Aus Rabatter ginn Erspuernisser',
      body: 'Monatlech Erspuernis amplaz monatlech Belaaschtung. Aus Rabatter entstinn Erspuernisser – an dës bezuelen genee déi Saachen, fir déi s du soss all Mount aus eegener Täsch bezuelst.',
      line1Label: 'DS-Plan ab',
      line1Value: '$5.000',
      line2Label: 'mon. Rabatt',
      line2Value: '3%',
      line3Label: 'VIP-Paket 3',
      line3Value: '+3%',
      resultLabel: 'mon. Erspuernisser',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Wéi ass dat méiglech?',
    title: "Mir hunn d'Wäertschöpfungskette nei geduecht.",
    traditionalTitle: 'Den traditionelle Wee',
    traditionalSteps: [
      'Minn — Réidiamanten',
      'Tëschen-Händler — Akaaf',
      'Schläiferei — Schlëff',
      'Zertifizéierung (GIA)',
      'Diamantebourse — Grousshandel',
      'Grousshandel → Einzelhandel',
      'Bijoutieren → Endclient'
    ],
    traditionalNote: 'Ier en Diamant den Endclient erreecht, entstinn duerch Tëschen-, Grouss- an Einzelhandel erheblech Handelsspannen.',
    stigTitle: 'De STIG ROCK Wee',
    stigSteps: [
      'Direkte Kaf — Réidiamanten aus der Minn',
      'Schläifen & Zertifizéiere duerch eis Partner',
      'Verkaf un Endclienten & B2B Clienten',
      'Bis zu 4 Handelszyklen pro Joer'
    ],
    stigNote: "Mir duerchbriechen de Kreislaf a ginn d'Handelsspannen als Rabattgutschrëften un eis Cliente weider — bis zu 4 Handelszyklen während der DS-Plan-Lafzäit."
  },
  optionen: {
    overline: 'Deng Méiglechkeeten',
    title: 'Nom Oflaf vun dengem Solution Plan',
    items: [
      { title: 'Liwwere loossen', body: 'Diamanten (Karat) zum Präis vun dengem DS-Plan.' },
      { title: 'An eis verkafen', body: 'Réckverkaf zum vum dir bezuelte Kafpräis.' },
      { title: 'An Drëtt verkafen', body: 'Diamanten um fräie Maart verkafen.' }
    ]
  },
  einfacherWeg: {
    overline: 'Solution Pläne — eng eenzegaarteg Produktinnovatioun',
    title: 'Den einfache Wee',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Umeldung',
        body: 'Kontaktéier däin Empfeelungsgeber an erstellen e kostenlose Kont!'
      },
      { n: '02', icon: 'cart', title: 'Kaf vun engem Produkt', body: 'Scho vun $ 250,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Rabatter kréien',
        body: 'Kritt monatlech Rabattgutschrëften.'
      }
    ]
  },
  business: {
    overline: 'Bonusaarten',
    title: 'Den einfachsten a fairste Wee.',
    sub: 'Fënnef Bonus-Aarten — fir däin erfollegräiche Geschäftsopbau.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Bis Level 3, ab Karrierestuf Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Ab Sapphire — onendlech déif.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Op den Infinity Bonus – bis Level 5 · OUNI Qualifikatioun.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 Pools vum weltwäiten Ëmsaz.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Eemolbonus an Diamanten (Karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Dëse Bonus gëtt dir fir all nei gezeechent Solution Plan bis an den 3. Level bezuelt. Mat ganz gerénge Qualifikatioune schalt s du déi eenzel Levelen fräi.',
    total: 'Bis zu 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'vun Ufank un',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'ab Karrierestuf Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'ab Karrierestuf Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: "Ab der Karrierestuf Sapphire bass du fir eisen Infinity Bonusplan qualifizéiert. Du kriss 3% Bonus. Mat all neier Karrierestuf kommen weider Prozenter dobäi. Ass e Partner an dengem Team och qualifizéiert, kriss du d'Differenz vu Rang zu Rang.",
    exampleTitle: 'Beispill',
    exampleRows: [
      { label: 'Du bass Blue Diamond', value: '12%' },
      { label: 'Däi Partner ass Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Däin Infinity Bonus', value: '9%' },
    totalNote: 'Total bis zu 24% Infinity Bonus op all gezeechent Solution Pläne an dengem Team — onendlech déif.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Mat dësem Bonus profitéiers du vum Erfolleg vun dengem Team. Du kriss e Matching Bonus vu 5% op den Infinity Bonus vun dengen Partner — an dat bis an déi 5. Ebene vun dengem Team.',
    note: 'Op all Infinity Bonus-Zuelungen an dengem Team – bis an den 5. Level. Vun Ufank un – OUNI Qualifikatioun.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Total bis zu',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: "3% vum weltwäiten Ëmsaz fléissen zu gläichen Deeler an 3 verschidde Pools. Duerch d'Erreeche vu bestëmmte Karrierestufen qualifizéiers du dech fir all eenzele Pool.",
    forever: 'Eemol erreecht – fir ËMMER bedeelegt!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'ab Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'ab Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'ab Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Total',
    totalValue: '3%',
    totalSuffix: 'vum weltwäiten Ëmsaz'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Ab der Karrierestuf Diamond kriss du e Rang Bonus. Dëse gëtt an Diamanten (Karat) ausbezuelt. Hei handelt et sech ëm een Eemolbonus.',
    highlight: 'Diamanten (Karat) am Gesamtwäert vun',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'Karrierestufen',
    sub: "Fir d'Erreeche vun de jeweilege Karrierestufen zielt den historesche Gesamtëmsaz (HG). Dëse muss ab der Stuf Sapphire op méi Teams verdeelt sinn. Fir Ruby oder méi héich ze erreechen, brauchs du op d'mannst zwee direkt Partner mat engem Solution Plan.",
    forever: 'Eemol erreecht – fir ËMMER bestätegt!',
    footnote: 'HV = Historesche Gesamtëmsaz.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Start mat eis duerch',
    title: 'Déi richteg Zäit ass genee elo.',
    body: 'Dëst Businessmodell setzt nei Moossstief a vereent all Erfollegsfaktoren fir e laangfristeg nohaltegt an erfollegräicht Geschäft. Registréier dech nach haut, wiel däi Solution Plan an notz dës eemoleg Businesschance.',
    hint: 'Schwätz mat der Persoun, déi dech zu dëser Presentatioun agelueden huet — si huet e Registréierunge-Link fir dech.',
    formName: 'Numm',
    formEmail: 'E-Mail',
    formPhone: 'Telefon',
    formSubmit: 'Kontakt ophuelen',
    success: 'Villmools Merci — mir mellen eis diskret a perséinlech.',
    callCta: 'Uriff',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Rechtlechen Hiweis & Disclaimer',
    disclaimer: 'Dës Presentatioun déngt reng zur Informatioun a stellt keng Finanz-, Analage- oder Steierberodung duer. STIG ROCK ass kee Finanzprodukt, mee bezitt sech op natierlech Diamanten als Sachwäerter. Fir Wäertentwécklungen, Gewënn oder Erträg gëtt keng Garantie iwwerholl. Vergaangen Entwécklungen sinn keng Indikatioun fir zukünfteg Resultater. All duergestallt Berechnungen am Zesummenhang mat Kommissioune sinn reng exemplaresch a stellen och keng Garantie duer. Ännerunge vum Inhalt virbehalen — fräi Iwwersetzung (keng offiziell Iwwersetzung).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. All Rechter virbehalen.',
    version: 'Versioun: DS-12-2025 V3'
  },
  misc: { next: 'Nächst Sektioun' }
};

export default lb;
